import { combineEpics } from 'redux-observable';
import { combineReducers } from 'redux';
import { catchError } from 'rxjs/operators';

import authUserBalanceEpic from '../containers/Auth/authEpic';
import submitCheckoutEpic from '../containers/Checkout/checkoutEpic';
import submitTokenEpic from '../containers/Token/tokenEpic';

import authSlice from '../containers/Auth/authSlice';
import cartSlice from '../containers/Cart/cartSlice';
import checkoutSlice from '../containers/Checkout/checkoutSlice';
import tokenSlice from '../containers/Token/tokenSlice';

const epics = combineEpics(...authUserBalanceEpic, ...submitCheckoutEpic, ...submitTokenEpic);

const rootReducer = combineReducers({
	authSlice,
	cartSlice,
	checkoutSlice,
	tokenSlice
});

const rootEpic = (action$, store$, dependencies) =>
	epics(action$, store$, dependencies).pipe(
		catchError((error, source) => {
			console.error('Root Epic Error Catcher', error);
			return source;
		})
	);

export { rootEpic, rootReducer };
